import { CommonModule, Location } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, RouterLink } from '@angular/router';
import { UserService } from '@kortobaa-front/authentication';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { PlatformService } from '../../..//core/services/platform.service';
import { FirebaseService } from '../../../core/services/firebase.service';
import { ConfirmDialogComponent } from '../../../shared/dialogs/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-side-menu',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule, MatIconModule],
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent {
  @Output() toggleSubMenu: EventEmitter<any> = new EventEmitter();
  @Input() sideNavToggleBtn!: boolean;
  @Input() subMenu!: boolean;
  openFlag: boolean = false;
  routeTitle: string = '';
  route!: any;
  sideMenu = [
    {
      id: 'home',
      title: 'home',
      route: '/home',
      icon: 'home',
      hasChildren: false,
      children: [] as any,
    },
    {
      id: 'managers-accounts',
      title: 'managers-accounts',
      route: '/managers-accounts/supervisors-accounts',
      icon: 'person_shield',
      hasChildren: true,
      children: [
        {
          title: 'supervisors-accounts',
          route: '/managers-accounts/supervisors-accounts',
        },
        {
          title: 'dispatchers-accounts',
          route: '/managers-accounts/dispatchers-accounts',
        },
      ],
      allowedRoles: ['superAdmin'],
    },
    {
      id: 'accounts',
      title: 'users-accounts',
      route: '/users-accounts/users-requests',
      icon: 'group',
      hasChildren: true,
      children: [
        {
          title: 'users-requests',
          route: '/users-accounts/users-requests',
        },
        {
          title: 'users-list',
          route: '/users-accounts/users-list',
          allowedRoles: ['superAdmin'],
        },
      ],
      allowedRoles: ['superAdmin', 'supervisor'],
    },
    {
      id: 'donors-accounts',
      title: 'donors-accounts',
      route: '/donors-accounts/individuals-donors-list',
      icon: 'supervisor_account',
      hasChildren: true,
      children: [
        {
          title: 'individuals-donors-list',
          route: '/donors-accounts/individuals-donors-list',
        },
        {
          title: 'corps-donors-list',
          route: '/donors-accounts/corps-donors-list',
        },
      ],
      allowedRoles: ['superAdmin','supervisor'],
    },
    {
      id: 'donation-requests',
      title: 'donation-requests',
      route: '/individuals-donation-requests',
      icon: 'volunteer_activism',
      hasChildren: true,
      children: [
        {
          title: 'individuals-donation-requests',
          route: '/individuals-donation-requests',
        },
        {
          title: 'corps-donation-requests',
          route: '/corps-donation-requests',
          // allowedRoles: ['superAdmin', 'supervisor'],
        },
        {
          title: 'individuals-furniture-donation-requests',
          route: '/individuals-furniture-donation-requests',
          // allowedRoles: ['superAdmin', 'supervisor'],
        },
        {
          title: 'corps-furniture-donation-requests',
          route: '/corps-furniture-donation-requests',
        },
      ] as any,
      allowedRoles: ['superAdmin', 'supervisor', 'receivingDispatcherOfficer'],
    },
    {
      id: 'users-requests',
      title: 'users-orders-requests',
      route: '/users-orders-requests/free-clothes-requests',
      icon: 'add_business',
      hasChildren: true,
      children: [
        {
          title: 'free-clothes-requests',
          route: '/users-orders-requests/free-clothes-requests',
          allowedRoles: ['superAdmin', 'supervisor'],
        },
        {
          title: 'approved-clothes-requests',
          route: '/users-orders-requests/approved-clothes-requests',
          allowedRoles: [
            'superAdmin',
            'supervisor',
            'receivingDispatcherOfficer',
          ],
        },
      ],
    },
    {
      id: 'reports',
      title: 'reports',
      route: '/reports',
      icon: 'bar_chart',
      hasChildren: true,
      children: [
        {
          title: 'donation-reports',
          route: '/reports/donation-reports',
          hasChildren: true,
          children: [
            {
              title: 'individuals-clothes-reports',
              route: '/reports/donation-reports/individuals-clothes-reports',
            },
            {
              title: 'corps-clothes-reports',
              route: '/reports/donation-reports/corps-clothes-reports',
            },
            {
              title: 'individuals-furniture-reports',
              route: '/reports/donation-reports/individuals-furniture-reports',
            },
            {
              title: 'corps-furniture-reports',
              route: '/reports/donation-reports/corps-furniture-reports',
            },
          ],
        },
        {
          title: 'users-orders-reports',
          route: '/reports/users-orders-reports',
          hasChildren: false,
        },
        {
          title: 'stock-reports',
          route: '/reports/stock-reports',
          hasChildren: false,
        },
      ],
      allowedRoles: ['superAdmin','supervisor'],
    },
    {
      title: 'settings',
      route: '/cart-configuration',
      icon: 'settings',
      hasChildren: true,
      id: 'settings',
      children: [
        {
          title: 'cart-configuration',
          route: '/cart-configuration',
        },
        {
          title: 'charity-organizations',
          route: '/charity-organizations',
        },
      ],
      allowedRoles: ['superAdmin'],
    },
  ];
  @Output() sideNavToggleBtnRes = new EventEmitter<boolean>();
  secondaryColor = 'var(--primary-color)';
  activeChildRoute!: string;
  activeNestedRoute?: string;
  openSubMenus: Record<string, boolean> = {};

  constructor(
    private _router: Router,
    location: Location,
    private _dialog: MatDialog,
    private _user: UserService,
    private _snackBar: MatSnackBar,
    private _firebase: FirebaseService,
    public _platForm: PlatformService,
    public _translate: TranslateService
  ) {
    this._router.events.subscribe((val) => {
      if (location.path() != '') {
        let routing = location.path().split('/');
        this.route = location.path();
        // this.activeChildRoute = routing[routing.length - 1];
        this.activeChildRoute =
          routing.length > 3
            ? routing[routing.length - 2]
            : routing[routing.length - 1];
        this.activeNestedRoute = routing[routing.length - 1];
      }
    });
  }

  //toggle function to open and close sub menu in side nav bar
  toggle(value: boolean, openFlag: boolean, title?: string) {
    if (value && this.routeTitle != title) {
      value = true;
      if (title) this.routeTitle = title;
    } else {
      value = false;
      this.routeTitle = '';
    }
    this.openFlag = value;
    this.subMenu = value;
    this.toggleSubMenu.emit(value);
    // opening a different parent or closing current parent -> close any opened child sub-menus
    this.openSubMenus = {};
  }

  // toggle a child that has its own children (nested)
  toggleChild(title: string, parent?: string, event?: Event) {
    if (event) event.stopPropagation();
    const key = parent ? `${parent}>${title}` : title;
    // close sibling children under same parent
    if (parent) {
      Object.keys(this.openSubMenus).forEach((k) => {
        if (k.startsWith(`${parent}>`) && k !== key) {
          delete this.openSubMenus[k];
        }
      });
    } else {
      // if no parent provided, close other top-level child keys (optional)
      Object.keys(this.openSubMenus).forEach((k) => {
        if (!k.includes('>') && k !== key) {
          delete this.openSubMenus[k];
        }
      });
    }
    this.openSubMenus[key] = !this.openSubMenus[key];
  }

  isChildOpen(title: string, parent?: string) {
    const key = parent ? `${parent}>${title}` : title;
    return !!this.openSubMenus[key];
  }

  // go to pages
  goTo(route: string) {
    // check when side nav is close close sub menu when route
    if (this.sideNavToggleBtn) {
      this.toggle(false, false);
    }
    this._router.navigateByUrl(route);
    this.sideNavToggleBtnRes.emit(false);
  }

  // logout
  async logout() {
    const isLogout: boolean = await firstValueFrom(
      this._dialog
        .open(ConfirmDialogComponent, {
          width: '26.25rem',
          data: {
            title: this._translate.instant('login.logout'),
            content: this._translate.instant('login.are-you-want-logout'),
            action: {
              accept: 'yes',
              refuse: 'cancel',
              color: this.secondaryColor,
            },
          },
        })
        .afterClosed()
    );

    if (isLogout) {
      this._snackBar
        .open(this._translate.instant('confirm-dialog.logout-message'), '', {
          panelClass: 'success-snackbar',
          duration: 1500,
        })
        .afterDismissed()
        .subscribe(() => {
          this._firebase.logout().subscribe();
          this._user.logout();
          this._router.navigate(['/login']);
          this._dialog.closeAll();
          localStorage.removeItem('vendureToken');
        });
    }
  }

  getCurrentRole() {
    if (!this._user.currentUser || !this._user.currentUser.roles) {
      return '';
    }
    return this._user.currentUser.roles[0];
  }
}
